const removeFirstCharacter = (value: string) => value.slice(1);
export default removeFirstCharacter;
